// Retries a Supabase-style call only on network failures (no DB error code).
type Result<T> = { data: T | null; error: any };

export function isNetworkError(err: any): boolean {
  if (!err) return false;
  if (err.code) return false; // real database / PostgREST error
  const msg = String(err.message ?? err);
  return /failed to fetch|networkerror|load failed|network request failed|fetch/i.test(msg);
}

export async function withNetworkRetry<T>(
  fn: () => PromiseLike<Result<T>>,
  delays: number[] = [500, 1000],
): Promise<Result<T>> {
  let attempt = 0;
  for (;;) {
    let res: Result<T>;
    try {
      res = await fn();
    } catch (e) {
      res = { data: null, error: e };
    }
    if (!res.error || !isNetworkError(res.error) || attempt >= delays.length) return res;
    await new Promise((r) => setTimeout(r, delays[attempt++]));
  }
}

export const SEARCH_NETWORK_ERROR = "Couldn't reach the server — check your connection and try again.";
